export const formatMobileNumber = (mobileNumber: string) => {
  return mobileNumber.replace(/\D+/g, '').replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3');
};
